// 由 EB view/admin/src/router/modules/app.js 转换；仅注册已有 views 页面
// 公众号菜单/自动回复/图文/模板消息等页面暂无，暂不接入
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router';
import { roterPre } from '@/setting';

const appRouter: RouteRecordRaw = {
  path: `${roterPre}/app`,
  name: 'app',
  meta: {
    title: '公众号',
  },
  alwaysShow: true,
  component: Layout,
  children: [
    {
      path: 'wechat/file',
      name: 'WechatFile',
      meta: {
        title: '上传校验文件',
        noCache: true,
      },
      component: () => import('@/views/app/wechat/file/index.vue'),
    },
    {
      path: 'routine/download',
      name: 'RoutineDownload',
      meta: {
        title: '小程序下载',
        noCache: true,
      },
      component: () => import('@/views/app/routine/download/index.vue'),
    },
    /*
     * 暂不接入：wechat/menus、wechat/reply、wechat/newsCategory、wechat/template
     */
  ],
};

export default appRouter;
